import React, {useState} from 'react';
import {Button} from '../../components/Button';
import {H3} from '../../components/H3';
import {Select} from '../../components/Select';
import {TextArea} from '../../components/TextArea';
import {TextField} from '../../components/TextField';
import {useForm} from "react-hook-form";
import {CustomerMailRequest} from "../../types/types";
import {postCustomerRequest} from "../../apis/contents";
import {nToast} from "../../plugins/reactToast";

export const ContactUsPage = () => {
    const form = useForm<CustomerMailRequest>();
    const [files, setFiles] = useState<File[]>([]);

    const onSubmit = (request: CustomerMailRequest) => {
        postCustomerRequest(request, files).then(r => {
            nToast(`문의 사항이 전달되었습니다`);
            form.reset();
        }).catch(e => {
            if(e.response.data.message) {
                nToast(e.response.data.message);
            }else{
                nToast(`문의 사항 전송에 실패하였습니다.`);
            }
        });
    }

    return (
        <div className="p-3 md:p-3 pl-10 bgcolorf5f5f5 -mx-8 md:-mt-10 mt-0">
            <form onSubmit={form.handleSubmit(onSubmit)}>
                <div className="space-y-3 pb-20 max-w-3xl m-auto pt-10">
                    <H3 className="font-semibold text-center mb-10 text-16">문의하기</H3>

                    <div className="grid md:grid-cols-2 grid-cols-1 gap-x-5 gap-y-8">
                        <Select className="border-gray-700 border pl-4 bg-transparent h-16"
                                value={form.watch().type}
                                {...form.register('type', {required: true})}
                        >
                            <option hidden value={undefined}>유형을 선택해주세요</option>
                            <option value="ONLINE">온라인 스토어</option>
                            <option value="MARKETING">마케팅</option>
                            <option value="PARTNERSHIP">파트너쉽</option>
                            <option value="RECRUITING">구인공고</option>
                        </Select>
                        <TextField label="" placeholder="제목" className="border-gray-700 bg-transparent h-16 text-14"
                                   helper={form.formState.errors.title?.message}
                                   {...form.register(`title`, {required: '필수 입력 사항입니다'})}
                        />
                        <TextField label=""
                                   placeholder="이름"
                                   className="border-gray-700 bg-transparent h-16 text-14"
                                   helper={form.formState.errors.name?.message}
                                   {...form.register(`name`, {required: '필수 입력 사항입니다'})}
                        />
                        <TextField label=""
                                   placeholder="이메일"
                                   className="border-gray-700 bg-transparent h-16 text-14"
                                   helper={form.formState.errors.email?.message}
                                   {...form.register(`email`, {required: '필수 입력 사항입니다'})}
                        />
                        </div>
                    <TextArea placeholder="내용을 입력해 주세요." className="border-gray-700 h-96 bg-transparent h-16 text-14 mt-10"
                              helper={form.formState.errors.contents?.message}
                              {...form.register(`contents`, {required: '필수 입력 사항입니다'})}
                    />

                    <div className="flex flex-row space-x-8">
                        <div className="flex-1 border-b mt-2 border-gray-700 text-gray-400 text-14">파일 업로드</div>
                        <button type={'button'} className="bg-gray-900 text-white py-2 px-4 text-14"
                                onClick={() => document.getElementById("file")?.click()}
                        >문서
                        </button>
                        <input type="file" name="file" id="file" style={{display: "none"}}
                               onChange={(e) => {
                                   e.target.files && e.target.validity.valid && setFiles([...files, e.target.files[0]]);
                               }}
                        />
                    </div>
                    {files.length > 0 && files.map((file, index) => (
                        <div className={'flex space-x-8 text-14 mt-2 relative max-w-xs'} key={index}>
                            <p>{file.name}</p>
                            <button type={'button'}
                                    className="bg-gray-300 text-gray text-12 p-1 absolute right-0"
                                    onClick={() => setFiles(files.filter(f => f !== file))}
                            >삭제
                            </button>
                        </div>
                    ))}


                    <div className="text-14 space-y-2 pt-10">
                        <p className="">개인정보 수집 및 이용에 대한 동의</p>
                        <p className="border border-gray-700 p-4">
                            1. 수집 목적: 서비스 이용에 따른 본인 확인 및 결과 회신, 서비스
                            진행에 따른 필요 정보 획득 및 응대 목적 <br/>
                            2. 수집 항목: 이름, 이메일주소
                            <br/> 3. 보유 및 이용기간: 문의 처리 후 6개월간 보관 후 폐기
                            <br/>
                            웍스아웃은 서비스 이용을 위해 필요한 최소한의 개인정보만을
                            수집합니다.
                            <br/> 수집하는 개인정보 필수항목을 입력하지 않을 시 서비스 이용에
                            제한이 있을 수 있습니다.
                        </p>
                    </div>

                    <div className="grid place-items-end pt-8">
                        <div className="grid grid-cols-2 w-56 gap-4">
                            <Button type={'button'} text="취소하기" className="outlined-gray-900"/>
                            <Button type={'submit'} text="보내기" className="filled-gray-900"/>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};
